// src/data/newsCoverageData.js
// Earned media coverage for Project Ontario

export const newsCoverageData = [
  {
    id: 'news-globalnews-2026-06-24',
    title:
      "Doug Ford pushes back on negative polling as some conservatives begin ‘contingency planning’",
    summary:
      "Premier Doug Ford dismisses negative polling data, insisting his party's internal metrics show stronger support, even as some conservatives reportedly begin 'contingency planning'.",
    source: 'Global News',
    publishDate: '2026-06-24',
    imageUrl:
      'https://globalnews.ca/wp-content/uploads/2026/05/CP176246650.jpg?quality=65&strip=all&w=720&h=379&crop=1',
    link: 'https://globalnews.ca/news/11929950/doug-ford-pushes-back-on-negative-polling-as-some-conservatives-begin-contingency-planning/',
    author: "Colin D'Mello and Isaac Callan",
    postedTime: '2026-06-24 9:00 AM EST',
  },
  {
    id: 'news-cbc-2026-01-30',
    title:
      "Ontario PCs gather this weekend, as some conservatives push for change in government’s direction",
    summary:
      "Conservative group urging delegates to push for broader debate on key issues.",
    source: 'CBC News',
    publishDate: '2026-01-30',
    imageUrl:
      'https://i.cbc.ca/ais/fec65690-2381-432d-89e2-470648c69c50,1769716320958/full/max/0/default.jpg?im=Crop%2Crect%3D%280%2C336%2C6451%2C3628%29%3BResize%3D860',
    link: 'https://www.cbc.ca/news/canada/toronto/ontario-pc-convention-project-ontario-9.7067023',
    author: 'Shawn Jeffords',
    postedTime: '2026-01-30 4:00 AM EST',
  },
  {
    id: 'news-theline-2025-11-11',
    title: 'On The Line: When did Doug Ford turn into a liberal?',
    summary:
      'Jen Gerson interviews Project Ontario organizer Matt Spoke about why the Ford PCs are governing like Liberals and how the movement is pushing for merit-driven, modern conservative policy.',
    source: 'The Line',
    publishDate: '2025-11-11',
    imageUrl: 'https://substack-post-media.s3.amazonaws.com/public/images/35adba23-a0f1-4bb7-b92b-198574ebe238_1280x720.png',
    link: 'https://www.readtheline.ca/p/on-the-line-when-did-doug-ford-turn',
  },
  {
    id: 'news-qpbriefing-2025-10-01',
    title: "Inside Project Ontario's first meeting, and what they want from the PCs",
    summary:
      "Project Ontario bills itself as a coalition of small-c conservatives, frustrated centrists, and disaffected PC voters who believe the Ford government is coasting while avoiding difficult choices on housing, education, and healthcare.",
    source: 'QP Briefing',
    publishDate: '2025-10-01',
    imageUrl: 'https://cdn.sanity.io/images/1sx0ve6y/production/22a0e75b9d12a6c44f94349bffa33df52c54cce7-5000x3333.jpg',
    link: 'https://www.qpbriefing.com/news/inside-project-ontario-s-first-meeting-and-what-they-want-from-the-pcs',
  },
  {
    id: 'news-thestar-2025-10-04',
    title: 'Is there a new Common Sense Revolution taking shape?',
    summary:
      'A generation of young, smart, right-leaning activists is talking about the change they feel is needed in Ontario.',
    source: 'Toronto Star',
    publishDate: '2025-10-04',
    imageUrl:
      'https://bloximages.chicago2.vip.townnews.com/thestar.com/content/tncms/assets/v3/editorial/a/e9/ae966985-7ff9-53af-ad39-0fe644af77bb/68e00d70497a2.image.jpg?crop=1670%2C877%2C0%2C182&resize=1200%2C630&order=crop%2Cresize',
    link: 'https://www.thestar.com/politics/provincial/is-there-a-new-common-sense-revolution-taking-shape/article_e019ecc3-4819-40ed-a6f5-4b93ac8d320d.html',
  },
  {
    id: 'news-nationalpost-2025-10-01',
    title: "Chris Selley: If there's a 'bunch of yahoos' in Ontario politics, it's certainly not Project Ontario",
    summary:
      "The group is best thought of as conservatives alarmed by some of Ontario's fundamentals and uninterested in being in power for its own sake.",
    source: 'National Post',
    publishDate: '2025-10-01',
    imageUrl: 'https://smartcdn.gprod.postmedia.digital/nationalpost/wp-content/uploads/2025/10/ford-20250919_298916835.jpg',
    link: 'https://nationalpost.com/opinion/chris-selley-if-theres-a-bunch-of-yahoos-in-ontario-politics-its-certainly-not-project-ontario',
  },
  {
    id: 'news-thestar-2025-09-28',
    title: "Members of his own party worry Doug Ford isn't conservative enough. His supporters say, so what?",
    summary:
      'Some Tories say the three-term premier is drifting too far to the mushy middle of the political spectrum.',
    source: 'Toronto Star',
    publishDate: '2025-09-28',
    imageUrl:
      'https://bloximages.chicago2.vip.townnews.com/thestar.com/content/tncms/assets/v3/editorial/5/93/593ffc88-efd0-5f75-9e70-b61ed0171c97/68d6e1e929a34.image.jpg?crop=1763%2C926%2C0%2C124&resize=1200%2C630&order=crop%2Cresize',
    link: 'https://www.thestar.com/politics/provincial/members-of-his-own-party-worry-doug-ford-isnt-conservative-enough-his-supporters-say-so/article_966aed36-3971-45e0-a74c-4a21c2e667d3.html',
  },
  {
    id: 'news-globeandmail-2025-09-30',
    title: 'New group Project Ontario takes aim at Doug Ford, who dismisses them as radicals',
    summary:
      "Group calls for rightward policy shifts on spending, education, and health care while Premier Ford calls them 'yahoos'.",
    source: 'The Globe and Mail',
    publishDate: '2025-09-30',
    imageUrl:
      'https://www.theglobeandmail.com/resizer/v2/LLXTK6TAC5ALXEJ5PSDQQKDTCE.JPG?auth=fa5f0c3fc762276335e856345b1aec5c64df96d848c68dd7f1101af7e87aa924&width=1200&height=800&quality=80&smart=true',
    link: 'https://www.theglobeandmail.com/canada/article-doug-ford-dismisses-project-ontario-as-yahoos/',
  },
  {
    id: 'news-cbc-2025-06-11',
    title: "ANALYSIS | Who's behind 'Project Ontario,' the group pushing Doug Ford to be more conservative?",
    summary:
      "There's a quiet and mysterious move afoot to push Premier Doug Ford's Ontario PC government to adopt more fiscally conservative policies.",
    source: 'CBC News',
    publishDate: '2025-06-11',
    imageUrl:
      'https://i.cbc.ca/ais/1.7471051,1740715221000/full/max/0/default.jpg?im=Crop%2Crect%3D%280%2C494%2C4720%2C2655%29%3BResize%3D620',
    link: 'https://www.cbc.ca/news/canada/toronto/project-ontario-doug-ford-pc-party-conservatives-1.7556576',
  },
  {
    id: 'news-hub-2025-10-03',
    title: "'We're in his head': Conservative group aims to hold Doug Ford accountable for 'inaction' as premier",
    summary:
      "Project Ontario organizers say they plan to keep pressing the Ford government on housing, education, and affordability by building a wider grassroots coalition.",
    source: 'The Hub',
    publishDate: '2025-10-03',
    imageUrl: 'https://thehub.ca/wp-content/uploads/2025/10/CP174150064-960x540.jpg',
    link: 'https://thehub.ca/2025/10/03/were-in-his-head-conservative-project-ontario-aims-doug-ford-accountable-inaction-premier/',
  },
];

export const getProjectOntarioNews = () => {
  return [...newsCoverageData].sort(
    (a, b) => new Date(b.publishDate) - new Date(a.publishDate)
  );
};

